import {
  defineMessages as dMessages,
  FormattedMessage as FMessage,
  type IntlFormatters,
  type IntlShape,
  type MessageDescriptor,
  useIntl as uIntl,
} from 'react-intl'
import type { BaseTranslations } from './locales'

type TypedMessageDescriptor = MessageDescriptor & {
  id: keyof BaseTranslations
}

type DefineMessages = <KT extends string = string>(
  msgs: Record<KT, keyof BaseTranslations>
) => Record<KT, TypedMessageDescriptor>

/**
 * @deprecated use defineMessages instead
 */
export const defineMessagesDeprecated: DefineMessages = msgs =>
  dMessages(
    Object.fromEntries(
      Object.entries(msgs).map(([key, value]) => [key, { id: value }])
    ) as ReturnType<DefineMessages>
  )

/**
 * @deprecated use FormattedMessage instead
 */
export const FormattedMessageDeprecated = (
  props: React.ComponentProps<typeof FMessage> & TypedMessageDescriptor
) => <FMessage {...props} />

type Tail<T extends unknown[]> = T extends [unknown, ...infer Rest] ? Rest : T

type FormatMessageFn =
  | IntlFormatters['formatMessage']
  | IntlFormatters<React.ReactNode>['formatMessage']
type FormatMessage = (
  descriptor: TypedMessageDescriptor,
  ...args: Tail<Parameters<FormatMessageFn>>
) => string

type TypedIntlShape = Omit<IntlShape, 'formatMessage'> & { formatMessage: FormatMessage }

/**
 * @deprecated use useIntl instead
 */
export const useIntlDeprecated = () => uIntl() as TypedIntlShape
